import { fnPostUrl } from "functions/Api"

export const postUpdateSupplier=(data)=>{
    const apiRequest = {
        endpoint: '/api/ProvWeb/Supplier/UpdateSupplier',
        body:data,
        useBasic:true
    }
    return fnPostUrl(apiRequest)
}